import { useGetQuery } from "../hooks";
import { useDataContext, useUserContext } from "../contexts";
import { getPerformedResponsibilityFields } from "../utils";
import Form from "./Form";

export default function PerformedResponsibilityEdit({ callback, id }) {
  const { user } = useUserContext();
  const { memberUsers, responsibilities } = useDataContext();

  const performedResponsibilitiesQuery = useGetQuery(
    "performed-responsibilities"
  );

  if (performedResponsibilitiesQuery.isLoading) {
    return null;
  }

  const performedResponsibility = performedResponsibilitiesQuery.data.find(
    (performedResponsibility) => performedResponsibility.id === id
  );

  if (!performedResponsibility) {
    return "Performed responsibility not found";
  }

  const performedResponsibilityFields = getPerformedResponsibilityFields(
    user,
    memberUsers,
    responsibilities
  );

  return (
    <Form
      path="performed-responsibilities"
      id={performedResponsibility.id}
      method="PATCH"
      submitCallback={callback}
      initialValues={performedResponsibility}
      fields={performedResponsibilityFields}
    />
  );
}
